module.exports = __webpack_public_path__ + "static/media/login-bg.65db0843.jpg";